<template>
    <div class="woocommerce-notices-wrapper">
    </div>
</template>

<script lang="ts" setup>
    import type { IWooNotice } from '~/types/wooNotice';
    const wooNotice = ref<IWooNotice>({
        message: '',
        type: ''
    }); 
</script>
<style lang="scss">
@import url("@/assets/scss/components/product/_single-noti.scss");
</style>

<style lang="scss">
.button.wc-forward {
    background: white;
    border: 1px solid black;
    border-radius: 0;
    text-transform: uppercase;
    font-weight: 400;
    float: right;
    font-size: 14px;
    padding: 0.618em 1em;
    text-decoration: none;
    color: #88888D;
}
</style>